import {FETCH_TEMPORARY_EQUIPMENT} from "./types";

const initialState = {
    temporary_equipment:[],
}
export const temporaryEquipmentReducer=(state = initialState, action)=> {
    switch (action.type) {
        case FETCH_TEMPORARY_EQUIPMENT:
            return {...state, temporary_equipment: action.payload}
        default:
            return state;
    }
}
